module.exports = __webpack_public_path__ + "img/b1.89dc5383.png";